import React from "react";
import kitoLogo from '../assets/images/kito-logo.avif';

function Footer() {
  return (
    <footer className="bg-orange text-white py-4">
      <div className="container">
        <div className="footer-logo mb-4">
          <img 
            src={kitoLogo}
            alt="Kito"
            style={{ height: '30px' }}
          />
        </div>
        <div className="border-top border-white-50 pt-4">
          <div className="row">
            <div className="col-md-6 mb-3 mb-md-0">
              <span className="copyright">© 2025 Kito. All rights reserved</span>
            </div>
            <div className="col-md-6">
              <div className="footer-links d-flex flex-wrap gap-3 justify-content-md-end">
                <a href="https://kito.pet/pages/uyelik-sozlesmesi" 
                   className="text-white text-decoration-none footer-link" 
                   target="_blank" 
                   rel="noopener noreferrer">
                  Üyelik Sözleşmesi
                </a>
                <a href="https://kito.pet/pages/mesafeli-satis-sozlesmesi" 
                   className="text-white text-decoration-none footer-link" 
                   target="_blank" 
                   rel="noopener noreferrer">
                  Mesafeli Satış Sözleşmesi
                </a>
                <a href="https://kito.pet/pages/gizlilik-politikasi" 
                   className="text-white text-decoration-none footer-link" 
                   target="_blank" 
                   rel="noopener noreferrer">
                  Gizlilik Politikası
                </a>
                <a href="https://kito.pet/pages/iptal-iade-kosullari" 
                   className="text-white text-decoration-none footer-link" 
                   target="_blank" 
                   rel="noopener noreferrer">
                  İptal & İade Koşulları
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>
        {`
          footer {
            margin-top: 2rem;
          }
          
          .footer-logo {
            display: flex;
            align-items: center;
          }
          
          .copyright {
            display: block;
            font-size: 0.9rem;
          }
          
          .footer-links {
            display: flex;
            flex-wrap: wrap;
          }
          
          .footer-link {
            position: relative;
            font-size: 0.9rem;
            padding: 0.25rem 0;
            transition: all 0.2s ease;
          }
          
          .footer-link:hover {
            text-decoration: underline !important;
            opacity: 0.9;
          }
          
          @media (max-width: 767px) {
            footer {
              padding-bottom: 1rem;
            }
            
            .footer-logo {
              justify-content: center;
            }
            
            .copyright {
              text-align: center;
              margin-bottom: 1rem;
            }
            
            .footer-links {
              justify-content: center !important;
              gap: 0.75rem 1.5rem !important;
            }
            
            .footer-link {
              text-align: center;
            }
            
            .col-md-6:first-child {
              margin-bottom: 1rem !important;
            }
          }
          
          @media (max-width: 480px) {
            .footer-links {
              flex-direction: column;
              align-items: center;
              gap: 0.75rem !important;
            }
            
            .footer-link {
              padding: 0.5rem 0;
            }
          }
        `}
      </style>
    </footer>
  );
}

export default Footer;
